import { render, staticRenderFns } from "./CreateStockist.vue?vue&type=template&id=73f10910&"
import script from "./CreateStockist.vue?vue&type=script&lang=js&"
export * from "./CreateStockist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports